// extracted by mini-css-extract-plugin
export default {"wrapper":"profile_card_cotent-module___wrapper___d860ca12"};